module.exports = __webpack_public_path__ + "static/media/finsite_services.35a8434a.jpg";